module.exports = __webpack_public_path__ + "static/img/shcygn9.6e9e4ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/shcygn9.png
// module id = 379
// module chunks = 0